import React from 'react';

const MessengerIcon = ({
  showNewUI = false,
  fillColor = '#983be3',
  size = '40',
}) =>
  showNewUI ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 19 18"
      fill="none">
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.2}
        d="M4.417 14.333v3l2.75-1.583c.75.25 1.583.333 2.5.333 4.583 0 8.333-3.416 8.333-7.75C18 4.083 14.25.667 9.667.667c-4.584 0-8.334 3.416-8.334 7.75 0 2.416 1.167 4.5 3.084 5.916Z"
      />
      <path
        stroke={fillColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.2}
        d="m9.083 6.667-3.166 3.75L9 9.667l1.25.75 3.167-3.75-2.917.75-1.417-.75Z"
      />
    </svg>
  ) : (
    <svg
      id="Messenger"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 72 72">
      <circle
        id="Ellipse_704"
        data-name="Ellipse 704"
        cx="36"
        cy="36"
        r="36"
        fill="rgba(41,97,250,0)"
      />
      <path
        id="Path_65858"
        data-name="Path 65858"
        d="M174.742,35.851a.886.886,0,0,1-.893-.844l-.1-3.287a2.112,2.112,0,0,0-.728-1.5A16.849,16.849,0,0,1,167.319,17.4v-.756A17.368,17.368,0,0,1,184.884,0h1.442A17.452,17.452,0,0,1,203.78,17.392c0,.256,0,.506,0,.756A17.375,17.375,0,0,1,186.23,34.784h-.687a20.365,20.365,0,0,1-5.315-.675,2.031,2.031,0,0,0-.57-.074,2.091,2.091,0,0,0-.858.175l-3.7,1.559a.787.787,0,0,1-.33.074Z"
        transform="translate(-149.257 17.611)"
        fill="none"
      />
      <path
        id="Path_65859"
        data-name="Path 65859"
        d="M174.732,35.857a.893.893,0,0,1-.893-.844l-.1-3.294a2.1,2.1,0,0,0-.728-1.505,16.862,16.862,0,0,1-5.706-12.823C167.309,7.485,175.151,0,185.554,0S203.8,7.471,203.8,17.372s-7.862,17.392-18.244,17.392a20.051,20.051,0,0,1-5.294-.675,2.316,2.316,0,0,0-.57-.074,2.216,2.216,0,0,0-.858.175l-3.742,1.579A.94.94,0,0,1,174.732,35.857Zm4.958-4.724a5.011,5.011,0,0,1,1.373.175,17.265,17.265,0,0,0,4.518.6,15.837,15.837,0,0,0,10.986-4.137,14.052,14.052,0,0,0,4.36-10.373,14.052,14.052,0,0,0-4.36-10.366,16.582,16.582,0,0,0-21.932,0,14.052,14.052,0,0,0-4.36,10.366,14,14,0,0,0,4.738,10.711,4.969,4.969,0,0,1,1.648,3.044l.865.472.172-.074a5.149,5.149,0,0,1,1.991-.432Z"
        transform="translate(-149.254 17.611)"
        fill={fillColor}
      />
      <path
        id="Path_65860"
        data-name="Path 65860"
        d="M179.679,28.428a.2.2,0,0,1-.165-.082.185.185,0,0,1,0-.213l5.088-8.061a1.971,1.971,0,0,1,1.669-.913,1.916,1.916,0,0,1,1.051.309l.13.089,4.058,3.056a1.662,1.662,0,0,0,2.005,0l5.493-4.168a.172.172,0,0,1,.11-.034.22.22,0,0,1,.158.082.2.2,0,0,1,0,.227L194.14,26.78a1.95,1.95,0,0,1-1.662.913,1.977,1.977,0,0,1-1.057-.309l-.13-.1-4.038-2.98a1.655,1.655,0,0,0-2,0l-5.493,4.12A.186.186,0,0,1,179.679,28.428Z"
        transform="translate(-153.068 11.544)"
        fill={fillColor}
      />
    </svg>
  );

export default MessengerIcon;
